<template>
  <div>
    <v-card class="mb-12" height="50px" :style="{ 'box-shadow': '0 0 black' }">
      <div class="d-flex flex-column justify-center">
        <h3 class="mb-5">Promo Details</h3>
      </div>
    </v-card>
    <v-row>
      <v-col cols="12">
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Nama Promo </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              id="promoName"
              ref="promoName"
              label="Nama Promo"
              v-model="promoName"
              @change="$v.promoName.$touch()"
              @blur="$v.promoName.$touch()"
              :error-messages="promoNameErrors"
              :disabled="disableForm"
            />
          </v-col>
        </v-row>

        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> QR Method </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-row align="center" class="pl-2">
              <v-checkbox
                id="qrMethodNpm"
                ref="qrMethodNpm"
                label="MPM"
                v-model="qrMethodNpm"
                @change="$v.qrMethodNpm.$touch()"
                @blur="$v.qrMethodNpm.$touch()"
                :error-messages="qrMethodNpmErrors"
                :disabled="disableForm"
              />
              <v-checkbox
                id="qrMethodCpm"
                ref="qrMethodCpm"
                label="CPM"
                v-model="qrMethodCpm"
                @change="$v.qrMethodCpm.$touch()"
                @blur="$v.qrMethodCpm.$touch()"
                :error-messages="qrMethodCpmErrors"
                class="ml-2"
                :disabled="disableForm"
              />
            </v-row>
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Payment Type </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-row align="center" class="pl-2">
              <v-checkbox
                id="paymentTypeOnUs"
                ref="paymentTypeOnUs"
                label="On Us"
                v-model="paymentTypeOnUs"
                @change="$v.paymentTypeOnUs.$touch()"
                @blur="$v.paymentTypeOnUs.$touch()"
                :error-messages="paymentTypeOnUsErrors"
                :disabled="disableForm"
              />
              <v-checkbox
                id="paymentTypeOffUs"
                ref="paymentTypeOffUs"
                label="Off Us"
                class="ml-2"
                v-model="paymentTypeOffUs"
                @change="$v.paymentTypeOffUs.$touch()"
                @blur="$v.paymentTypeOffUs.$touch()"
                :error-messages="paymentTypeOffUsErrors"
                :disabled="disableForm"
              />
            </v-row>
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Minimum Transaksi </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              id="minTransaction"
              ref="minTransaction"
              label="Minimum Transaksi"
              prefix="Rp"
              v-model="minTransaction"
              @change="$v.minTransaction.$touch()"
              @blur="$v.minTransaction.$touch()"
              :error-messages="minTransactionErrors"
              :disabled="disableForm"
            />
          </v-col>
        </v-row>

        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Periode Promo </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="promoPeriod"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  id="promoPeriod"
                  ref="promoPeriod"
                  label="Periode Promo"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  v-model="promoPeriod"
                  @change="$v.promoPeriod.$touch()"
                  @blur="$v.promoPeriod.$touch()"
                  :error-messages="promoPeriodErrors"
                  :disabled="disableForm"
                />
              </template>
              <v-date-picker
                v-model="promoPeriod"
                no-title
                scrollable
                range
                :min="date"
              >
                <v-spacer />
                <v-btn text color="primary" @click="menu = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="
                    () => {
                      checkRangeDate();
                      $refs.menu.save(promoPeriod);
                    }
                  "
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Promo per User </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-row>
              <v-col cols="6">
                <v-text-field
                  id="promoQuotaPerMerchant"
                  ref="promoQuotaPerMerchant"
                  label="Promo / Merchant"
                  v-model="promoQuotaPerMerchant"
                  @change="$v.promoQuotaPerMerchant.$touch()"
                  @blur="$v.promoQuotaPerMerchant.$touch()"
                  :error-messages="promoQuotaPerMerchantErrors"
                  :disabled="disableForm"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  id="promoQuotaPerCustomer"
                  ref="promoQuotaPerCustomer"
                  label="Promo / Customer"
                  v-model="promoQuotaPerCustomer"
                  @change="$v.promoQuotaPerCustomer.$touch()"
                  @blur="$v.promoQuotaPerCustomer.$touch()"
                  :error-messages="promoQuotaPerCustomerErrors"
                  :disabled="disableForm"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Promo per Hari </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-row>
              <v-col cols="6">
                <v-text-field
                  id="promoQuotaMerchantPerDay"
                  ref="promoQuotaMerchantPerDay"
                  label="Promo / Merchant"
                  v-model="promoQuotaMerchantPerDay"
                  @change="$v.promoQuotaMerchantPerDay.$touch()"
                  @blur="$v.promoQuotaMerchantPerDay.$touch()"
                  :error-messages="promoQuotaMerchantPerDayErrors"
                  :disabled="disableForm"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  id="promoQuotaCustomerPerDay"
                  ref="promoQuotaCustomerPerDay"
                  label="Promo / Customer"
                  v-model="promoQuotaCustomerPerDay"
                  @change="$v.promoQuotaCustomerPerDay.$touch()"
                  @blur="$v.promoQuotaCustomerPerDay.$touch()"
                  :error-messages="promoQuotaCustomerPerDayErrors"
                  :disabled="disableForm"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Jenis Promo </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-select
              id="jenisPromo"
              ref="jenisPromo"
              v-model="jenisPromo"
              @change="$v.jenisPromo.$touch()"
              @blur="$v.jenisPromo.$touch()"
              :error-messages="jenisPromoErrors"
              :items="jenisPromoList"
              label="Jenis Promo"
              :disabled="disableForm"
            />

            <v-radio-group
              v-if="jenisPromo"
              id="discountType"
              ref="discountType"
              v-model="discountType"
              @change="$v.discountType.$touch()"
              @blur="$v.discountType.$touch()"
              :error-messages="discountTypeErrors"
              row
              :disabled="disableForm"
            >
              <v-radio label="Percentage" :value="1" />

              <v-radio label="Fix Amount" :value="2" />
            </v-radio-group>

            <div v-if="discountType == 1">
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    id="percent"
                    ref="percent"
                    v-model="percent"
                    @change="$v.percent.$touch()"
                    @blur="$v.percent.$touch()"
                    :error-messages="percentErrors"
                    label="Percentage"
                    suffix="%"
                    :disabled="disableForm"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    id="maxDiscountAmount"
                    ref="maxDiscountAmount"
                    v-model="maxDiscountAmount"
                    @change="$v.maxDiscountAmount.$touch()"
                    @blur="$v.maxDiscountAmount.$touch()"
                    :error-messages="maxDiscountAmountErrors"
                    label="Maksimum Potongan"
                    prefix="Rp"
                    :disabled="disableForm"
                  />
                </v-col>
              </v-row>
            </div>
            <div v-if="discountType == 2">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    id="fixAmount"
                    ref="fixAmount"
                    v-model="fixAmount"
                    @change="$v.fixAmount.$touch()"
                    @blur="$v.fixAmount.$touch()"
                    :error-messages="fixAmountErrors"
                    label="Fix Amount"
                    prefix="Rp"
                    :disabled="disableForm"
                  />
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Syarat dan Ketentuan </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-textarea
              id="syaratDanKetentuan"
              ref="syaratDanKetentuan"
              v-model="syaratDanKetentuan"
              @change="$v.syaratDanKetentuan.$touch()"
              @blur="$v.syaratDanKetentuan.$touch()"
              :error-messages="syaratDanKetentuanErrors"
              label="Syarat dan Ketentuan"
            />
          </v-col>
        </v-row>
        <v-row v-if="showOnlyEdit" style="align-items: center">
          <v-col cols="10" sm="4"> Status </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-switch
              id="status"
              ref="status"
              v-model="status"
              label="Active"
              color="success"
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-btn small color="warning" dark @click="changeStep(1)">
          <v-icon dark left> mdi-arrow-left </v-icon>Kembali
        </v-btn>
      </v-col>
      <v-col cols="6" align="end">
        <v-btn
          small
          color="primary"
          dark
          @click="save"
          :loading="loading"
          :disabled="disabledEdit"
        >
          Save
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { required, numeric } from 'vuelidate/lib/validators';
import { scrollOptions, dataJenisPromoList } from '../../../store/params';
import { date, regexNumericDecimalOne } from '../../../lib/helpers';

export default {
  mixins: [validationMixin],
  validations: {
    promoName: {
      required,
    },
    qrMethodNpm: {
      required() {
        return this.qrMethodNpm != '' || this.qrMethodCpm != '';
      },
    },
    qrMethodCpm: {
      required() {
        return this.qrMethodCpm != '' || this.qrMethodNpm != '';
      },
    },
    paymentTypeOffUs: {
      required() {
        return this.paymentTypeOffUs != '' || this.paymentTypeOnUs != '';
      },
    },
    paymentTypeOnUs: {
      required() {
        return this.paymentTypeOffUs != '' || this.paymentTypeOnUs != '';
      },
    },
    minTransaction: {
      required,
      numericDecimal: regexNumericDecimalOne,
    },
    promoPeriod: { required },
    promoQuotaPerMerchant: { required, numeric },
    promoQuotaPerCustomer: { required, numeric },
    promoQuotaMerchantPerDay: {
      required,
      numeric,
      checkQuota() {
        return (
          parseInt(this.promoQuotaPerMerchant, 10) >=
          parseInt(this.promoQuotaMerchantPerDay, 10)
        );
      },
    },
    promoQuotaCustomerPerDay: {
      required,
      numeric,
      checkQuota() {
        return (
          parseInt(this.promoQuotaPerCustomer, 10) >=
          parseInt(this.promoQuotaCustomerPerDay, 10)
        );
      },
    },
    jenisPromo: { required },
    discountType: {
      required() {
        return this.jenisPromo && this.discountType !== '';
      },
    },
    percent: {
      required() {
        return this.discountType == 1 ? this.percent != '' : true;
      },
      maxVal() {
        return this.discountType == 1 ? this.percent <= 100 : true;
      },
      numeric,
    },
    maxDiscountAmount: {
      required() {
        return this.discountType == 1 ? this.maxDiscountAmount != '' : true;
      },
      numericDecimal: regexNumericDecimalOne,
    },
    fixAmount: {
      required() {
        return this.discountType == 2 ? this.fixAmount != '' : true;
      },
      numericDecimal: regexNumericDecimalOne,
      checkQuota() {
        return this.discountType == 2
          ? parseInt(this.minTransaction, 10) >= parseInt(this.fixAmount, 10)
          : true;
      },
    },
    syaratDanKetentuan: { required },
  },
  data: () => ({
    jenisPromoList: dataJenisPromoList,
    date,
    menu: false,
  }),
  computed: {
    showOnlyEdit() {
      return this.$route.params?.id || false;
    },
    disableForm() {
      return this.$store.state.promo.data?.disabled_form || false;
    },
    loading() {
      return this.$store.state.promo.loading;
    },
    status: {
      set(val) {
        this.$store.commit('promo/setDataVariable', {
          variable: 'status',
          payload: val,
        });
      },
      get() {
        return this.$store.state.promo.data.status;
      },
    },
    syaratDanKetentuan: {
      set(val) {
        this.$store.commit('promo/setDataVariable', {
          variable: 'syarat_dan_ketentuan',
          payload: val,
        });
      },
      get() {
        return this.$store.state.promo.data.syarat_dan_ketentuan;
      },
    },
    syaratDanKetentuanErrors() {
      const errors = [];
      if (!this.$v.syaratDanKetentuan.$dirty) return errors;
      if (!this.$v.syaratDanKetentuan.required)
        errors.push('Syarat dan Ketentuan is required');
      return errors;
    },
    fixAmount: {
      set(val) {
        this.$store.commit('promo/setDataVariable', {
          variable: 'fix_amount',
          payload: val,
        });
      },
      get() {
        return this.$store.state.promo.data.fix_amount;
      },
    },
    fixAmountErrors() {
      const errors = [];
      if (!this.$v.fixAmount.$dirty) return errors;
      if (!this.$v.fixAmount.required) errors.push('Fix amount is required');
      if (!this.$v.fixAmount.numericDecimal)
        errors.push('Fix amount is numeric decimal only');
      if (!this.$v.fixAmount.checkQuota)
        errors.push(`Fix amount maximal ${this.minTransaction}`);
      return errors;
    },
    maxDiscountAmount: {
      set(val) {
        this.$store.commit('promo/setDataVariable', {
          variable: 'max_discount_amount',
          payload: val,
        });
      },
      get() {
        return this.$store.state.promo.data.max_discount_amount;
      },
    },
    maxDiscountAmountErrors() {
      const errors = [];
      if (!this.$v.maxDiscountAmount.$dirty) return errors;
      if (!this.$v.maxDiscountAmount.required)
        errors.push('Maksimum Potongan is required');
      if (!this.$v.maxDiscountAmount.numericDecimal)
        errors.push('Maksimum Potongan is numeric decimal only');
      return errors;
    },
    percent: {
      set(val) {
        this.$store.commit('promo/setDataVariable', {
          variable: 'percent',
          payload: val,
        });
      },
      get() {
        return this.$store.state.promo.data.percent;
      },
    },
    percentErrors() {
      const errors = [];
      if (!this.$v.percent.$dirty) return errors;
      if (!this.$v.percent.required) errors.push('Percentage is required');
      if (!this.$v.percent.numeric) errors.push('Percentage is numeric only');
      if (!this.$v.percent.maxVal) errors.push('Percentage maximal 100%');
      return errors;
    },
    discountType: {
      set(val) {
        this.$store.commit('promo/setDataVariable', {
          variable: 'discount_type',
          payload: val,
        });
      },
      get() {
        return this.$store.state.promo.data.discount_type;
      },
    },
    discountTypeErrors() {
      const errors = [];
      if (!this.$v.discountType.$dirty) return errors;
      if (!this.$v.discountType.required)
        errors.push('Jenis potongan is required');
      return errors;
    },
    jenisPromo: {
      set(val) {
        this.$store.commit('promo/setDataVariable', {
          variable: 'jenis_promo',
          payload: val,
        });
      },
      get() {
        return this.$store.state.promo.data.jenis_promo;
      },
    },
    jenisPromoErrors() {
      const errors = [];
      if (!this.$v.jenisPromo.$dirty) return errors;
      if (!this.$v.jenisPromo.required) errors.push('Jenis promo is required');
      return errors;
    },
    promoQuotaMerchantPerDay: {
      set(val) {
        this.$store.commit('promo/setDataVariable', {
          variable: 'promo_quota_merchant_per_day',
          payload: val,
        });
      },
      get() {
        return this.$store.state.promo.data.promo_quota_merchant_per_day;
      },
    },
    promoQuotaMerchantPerDayErrors() {
      const errors = [];
      if (!this.$v.promoQuotaMerchantPerDay.$dirty) return errors;
      if (!this.$v.promoQuotaMerchantPerDay.required)
        errors.push('Promo per hari is required');
      if (!this.$v.promoQuotaMerchantPerDay.numeric)
        errors.push('Promo per hari is numeric only');
      if (!this.$v.promoQuotaMerchantPerDay.checkQuota)
        errors.push(`Promo per hari maximal ${this.promoQuotaPerMerchant}`);
      return errors;
    },
    promoQuotaCustomerPerDay: {
      set(val) {
        this.$store.commit('promo/setDataVariable', {
          variable: 'promo_quota_customer_per_day',
          payload: val,
        });
      },
      get() {
        return this.$store.state.promo.data.promo_quota_customer_per_day;
      },
    },
    promoQuotaCustomerPerDayErrors() {
      const errors = [];
      if (!this.$v.promoQuotaCustomerPerDay.$dirty) return errors;
      if (!this.$v.promoQuotaCustomerPerDay.required)
        errors.push('Promo per hari is required');
      if (!this.$v.promoQuotaCustomerPerDay.numeric)
        errors.push('Promo per hari is numeric only');
      if (!this.$v.promoQuotaCustomerPerDay.checkQuota)
        errors.push(`Promo per hari maximal ${this.promoQuotaPerCustomer}`);
      return errors;
    },
    promoQuotaPerMerchant: {
      set(val) {
        this.$store.commit('promo/setDataVariable', {
          variable: 'promo_quota_per_merchant',
          payload: val,
        });
      },
      get() {
        return this.$store.state.promo.data.promo_quota_per_merchant;
      },
    },
    promoQuotaPerMerchantErrors() {
      const errors = [];
      if (!this.$v.promoQuotaPerMerchant.$dirty) return errors;
      if (!this.$v.promoQuotaPerMerchant.required)
        errors.push('Promo per user is required');
      if (!this.$v.promoQuotaPerMerchant.numeric)
        errors.push('Promo per user is numeric only');
      return errors;
    },
    promoQuotaPerCustomer: {
      set(val) {
        this.$store.commit('promo/setDataVariable', {
          variable: 'promo_quota_per_customer',
          payload: val,
        });
      },
      get() {
        return this.$store.state.promo.data.promo_quota_per_customer;
      },
    },
    promoQuotaPerCustomerErrors() {
      const errors = [];
      if (!this.$v.promoQuotaPerCustomer.$dirty) return errors;
      if (!this.$v.promoQuotaPerCustomer.required)
        errors.push('Promo per user is required');
      if (!this.$v.promoQuotaPerCustomer.numeric)
        errors.push('Promo per user is numeric only');
      return errors;
    },
    promoPeriod: {
      set(val) {
        this.$store.commit('promo/setDataVariable', {
          variable: 'promo_period',
          payload: val.sort(),
        });
      },
      get() {
        return this.$store.state.promo.data.promo_period;
      },
    },
    promoPeriodErrors() {
      const errors = [];
      if (!this.$v.promoPeriod.$dirty) return errors;
      if (!this.$v.promoPeriod.required)
        errors.push('Periode promo is required');
      return errors;
    },
    minTransaction: {
      set(val) {
        this.$store.commit('promo/setDataVariable', {
          variable: 'min_transaction',
          payload: val,
        });
      },
      get() {
        return this.$store.state.promo.data.min_transaction;
      },
    },
    minTransactionErrors() {
      const errors = [];
      if (!this.$v.minTransaction.$dirty) return errors;
      if (!this.$v.minTransaction.required)
        errors.push('Minimum transaksi is required');
      if (!this.$v.minTransaction.numericDecimal)
        errors.push('Minimum transaksi is numeric decimal only');
      return errors;
    },
    paymentTypeOffUs: {
      set(val) {
        this.$store.commit('promo/setDataVariable', {
          variable: 'payment_type_off_us',
          payload: val,
        });
      },
      get() {
        return this.$store.state.promo.data.payment_type_off_us;
      },
    },
    paymentTypeOffUsErrors() {
      const errors = [];
      if (!this.$v.paymentTypeOffUs.$dirty) return errors;
      if (!this.$v.paymentTypeOffUs.required) errors.push('minimal one');
      return errors;
    },
    paymentTypeOnUs: {
      set(val) {
        this.$store.commit('promo/setDataVariable', {
          variable: 'payment_type_on_us',
          payload: val,
        });
      },
      get() {
        return this.$store.state.promo.data.payment_type_on_us;
      },
    },
    paymentTypeOnUsErrors() {
      const errors = [];
      if (!this.$v.paymentTypeOnUs.$dirty) return errors;
      if (!this.$v.paymentTypeOnUs.required) errors.push('minimal one');
      return errors;
    },
    qrMethodCpm: {
      set(val) {
        this.$store.commit('promo/setDataVariable', {
          variable: 'qr_method_cpm',
          payload: val,
        });
      },
      get() {
        return this.$store.state.promo.data.qr_method_cpm;
      },
    },
    qrMethodCpmErrors() {
      const errors = [];
      if (!this.$v.qrMethodCpm.$dirty) return errors;
      if (!this.$v.qrMethodCpm.required) errors.push('minimal one');
      return errors;
    },
    qrMethodNpm: {
      set(val) {
        this.$store.commit('promo/setDataVariable', {
          variable: 'qr_method_npm',
          payload: val,
        });
      },
      get() {
        return this.$store.state.promo.data.qr_method_npm;
      },
    },
    qrMethodNpmErrors() {
      const errors = [];
      if (!this.$v.qrMethodNpm.$dirty) return errors;
      if (!this.$v.qrMethodNpm.required) errors.push('minimal one');
      return errors;
    },
    promoName: {
      set(val) {
        this.$store.commit('promo/setDataVariable', {
          variable: 'promo_name',
          payload: val,
        });
      },
      get() {
        return this.$store.state.promo.data.promo_name;
      },
    },
    promoNameErrors() {
      const errors = [];
      if (!this.$v.promoName.$dirty) return errors;
      if (!this.$v.promoName.required) errors.push('Nama promo is required');
      return errors;
    },
    disabledEdit() {
      return this.$store.state.promo.data.disabled_edit;
    },
  },
  watch: {
    discountType(val) {
      if (val == 1) {
        this.$store.commit('promo/setDataVariable', {
          variable: 'fix_amount',
          payload: '',
        });
      } else {
        this.$store.commit('promo/setDataVariable', {
          variable: 'percent',
          payload: '',
        });

        this.$store.commit('promo/setDataVariable', {
          variable: 'max_discount_amount',
          payload: '',
        });
      }
    },
  },
  methods: {
    checkRangeDate() {
      if (this.promoPeriod.length == 1) {
        this.promoPeriod.push(this.promoPeriod[0]);
      }
    },
    changeStep(val) {
      this.$store.commit('promo/setStep', val);
    },
    async save() {
      const edit = !!this.$route.params.id;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        await this.$store
          .dispatch('promo/createPromo', {
            date,
            editAble: edit,
          })
          .then((status) => {
            if (status) {
              setTimeout(() => {
                this.$router.push({ path: '/promo' });
              }, 500);
            }
          });
      } else {
        this.scrollToErrorInput();
      }
    },
    scrollToErrorInput() {
      const keys = Object.keys(this.$v);
      let isError = false;

      keys.forEach((key) => {
        const input = key;

        if (input.includes('$')) return;

        if (this.$v[input].$error) {
          this.$vuetify.goTo(`#${input}`, scrollOptions);
          isError = true;
        }
      });

      if (!isError) this.$vuetify.goTo(0);
    },
  },
};
</script>
